import { StatusBadge } from '../../../components/StatusBadge/StatusBadge';
import { ItemStatusEnum } from '../../../api/payments/items/domain/enum';

const ITEM_STATUS_BADGES = {
  [ItemStatusEnum.ACTIVE]: { label: 'Ativo', variant: 'success' },
  [ItemStatusEnum.INACTIVE]: { label: 'Desativado', variant: 'danger' },
};

export function ItemStatusBadge({ item }) {
  const badge =
    ITEM_STATUS_BADGES[item?.statusType] ||
    ITEM_STATUS_BADGES[ItemStatusEnum.INACTIVE];

  return <StatusBadge label={badge.label} variant={badge.variant} />;
}
